import { render, staticRenderFns } from "./productBanner.vue?vue&type=template&id=1ea873b5&scoped=true&"
import script from "./productBanner.vue?vue&type=script&lang=js&"
export * from "./productBanner.vue?vue&type=script&lang=js&"
import style0 from "./productBanner.vue?vue&type=style&index=0&id=1ea873b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea873b5",
  null
  
)

export default component.exports